// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"d50a3545","78":"928b3e53","115":"66f34924","167":"5f839d94","201":"3d5aabd7","302":"532ed5e6","403":"57d796a2","488":"e8efcaf8","545":"0ee8d99f","817":"e744ac70","888":"743cfb62","896":"f6a2d61c","901":"d81e446a","935":"14964f55","998":"21655753"}[chunkId] + ".chunk.js";
};